/**
 * Plan Features - matches backend PlanFeature enum
 */
export enum PlanFeature {
  // Core Features
  AFFILIATES = 'AFFILIATES',
  AFFILIATE_PROGRAMS = 'AFFILIATE_PROGRAMS',
  CAMPAIGNS = 'CAMPAIGNS',
  POST_CHECKOUT_REFERRALS = 'POST_CHECKOUT_REFERRALS',
  
  // Advanced Features
  REVENUE_LOCK_SNEAKYLINK = 'REVENUE_LOCK_SNEAKYLINK',
  COMMISSION_RULES = 'COMMISSION_RULES',
  EMAIL_AUTOMATIONS = 'EMAIL_AUTOMATIONS', // Legacy - kept for backward compatibility
  WELCOME_EMAIL_AUTOMATION = 'WELCOME_EMAIL_AUTOMATION',
  NON_WELCOME_EMAIL_AUTOMATION = 'NON_WELCOME_EMAIL_AUTOMATION',
  TAX_FORMS_1099 = 'TAX_FORMS_1099',
  /** White-label affiliate portal: brand name + logo. Growth ($99) and up. */
  WHITE_LABEL = 'WHITE_LABEL',
  /** Full white-label customization: colours, custom domain, branded emails,
   *  brand-owned reward tiers. Scale ($249) and up. */
  WHITE_LABEL_FULL = 'WHITE_LABEL_FULL',
  SELF_SERVE_AUTO_CLEANING = 'SELF_SERVE_AUTO_CLEANING',
  
  // Support & Services
  LIVE_CHAT_SUPPORT = 'LIVE_CHAT_SUPPORT',
  PRIORITIZED_SUPPORT = 'PRIORITIZED_SUPPORT',
  DEDICATED_SUPPORT = 'DEDICATED_SUPPORT',
  CSM_AND_SLA = 'CSM_AND_SLA',
  
  // Product Management
  PRODUCTS = 'PRODUCTS',
  MULTI_PROGRAMS = 'MULTI_PROGRAMS',
  PROGRAM_NAMING = 'PROGRAM_NAMING',
  
  // Payout Features
  PAYOUTS = 'PAYOUTS',
  
  // Resource Sharing
  SHARE_RESOURCES = 'SHARE_RESOURCES',

  // Integrations
  /** TikTok Shop: connect a shop, sync affiliate sales, creator matching. Scale and up. */
  TIKTOK_SHOP = 'TIKTOK_SHOP',
  /** In-app assistant panel. Beta brands get it via ASSISTANT_BETA_SHOPS without the feature. */
  AI_ASSISTANT = 'AI_ASSISTANT',
}

export interface PlanLimits {
  approvedReferralsPerMonth: number | 'unlimited';
  maxAffiliates: number | 'unlimited';
  maxPrograms: number | 'unlimited';
}

export interface UserPermissions {
  planName: string;
  features: PlanFeature[];
  limits: PlanLimits;
  isGrandfathered: boolean;
}
